export default {
  customers: [],
  infoDB: {}
}
